import { ContractTypes } from '@draftkings/dk-data-layer';
import { MarketWithSelections } from '@draftkings/component-builder';

type ShouldShowScoresArgs = {
    marketsWithSelections: MarketWithSelections[];
    isTeamSwap: boolean;
};

/**
 * Determines if scores should be shown based on market selections.
 *
 * Returns TRUE when:
 * - Event is NOT team swap AND
 * - Selections exactly match one of these patterns:
 *   • Exactly 2 selections: Home + Away
 *   • Exactly 3 selections: Home + Tie + Away
 *
 * Returns FALSE when:
 * - Event is team swap
 * - No markets available
 * - Selection count doesn't match expected outcome types
 * - Missing any required outcome type
 * - Unexpected outcome types
 */
export const shouldShowScores = ({ marketsWithSelections, isTeamSwap }: ShouldShowScoresArgs): boolean => {
    if (isTeamSwap) {
        return false;
    }

    const firstMarket = marketsWithSelections[0];
    if (!firstMarket) {
        return false;
    }

    const selections = Array.from(firstMarket.selections.values()) as ContractTypes.Selection[];

    if (selectionsMatchOutcomeTypes(selections, ['Home', 'Tie', 'Away'])) {
        return true;
    }

    if (selectionsMatchOutcomeTypes(selections, ['Home', 'Away'])) {
        return true;
    }

    return false;
};

const selectionsMatchOutcomeTypes = (selections: ContractTypes.Selection[], outcomeTypes: string[]): boolean => {
    if (selections.length !== outcomeTypes.length) {
        return false;
    }

    const expectedSet = new Set(outcomeTypes.map((type) => type.toUpperCase()));

    return selections.every((s) => (s.outcomeType ? expectedSet.has(s.outcomeType.toUpperCase()) : false));
};
